export const mergeArray = (array, item, identifier = 'id', addToStart = false) => {
  return (array?.findIndex(e => parseInt(e[identifier]) === parseInt(item[identifier])) === -1)
    ?
    addToStart ? [item].concat(array) : array.concat([item])
    :
    array?.map(p => parseInt(p[identifier]) === parseInt(item[identifier]) ? item : p)
}